import { z } from 'zod';
import { BaseEventSchema } from '../Base';

export const PaymentAttemptEventSchema = BaseEventSchema.extend({
  payment_method_type: z.string(),
  charge_delivery_cost: z.boolean().optional(),
});

export const InsuranceToggleEventSchema = BaseEventSchema.extend({
  value: z.enum(['on', 'off']),
});

export const SelectInstallmentsEventSchema = BaseEventSchema.extend({
  quantity: z.number(),
});

export const RedirectPaymentMethodClickEventSchema = BaseEventSchema.extend({
  button_text: z.string(),
  payment_methods_registered: z.number().optional(),
});

export const ClickPrescriptionsNextEventSchema = BaseEventSchema.extend({
  response: z.enum(['success', 'missing_prescriptions', 'skipped']),
});

export const LastWhimCheckProduct = BaseEventSchema.extend({
  product_index_position: z.number(),
  product_id: z.number(),
  product_name: z.string(),
  last_whim_type: z.string().nullable(),
  last_whim_index: z.number().nullable(),
});

export const SelectInsuranceEventSchema = BaseEventSchema.extend({
  response: z.enum(['success', 'not_applicable', 'error']).nullable(),
});

export enum CheckoutInteractionEventTypes {
  RedirectNewPaymentMethod = 'interaction.redirect_new_payment_method',
  SelectInstallments = 'interaction.select_installments',
  PaymentAttempt = 'interaction.payment.attempt',
  PaymentCancel = 'interaction.payment.cancel',
  InsuranceToggle = 'interaction.checkout.insurance_toggle',
  GoToInsurance = 'interaction.checkout.go_to_insurance',
  ClickPrescriptionsNext = 'interaction.checkout.click_prescriptions_next',
  LastWhimCheckProduct = 'interaction.checkout.last_whim_check_product',
  SelectMekiCredit = 'interaction.select_meki_credit',
  UnselectMekiCredit = 'interaction.un_select_meki_credit',
  SelectInsurance = 'interaction.select_insurance',
  UnselectInsurance = 'interaction.un_select_insurance',
}

export const CheckoutInteractionEventTrackingSchemas = {
  [CheckoutInteractionEventTypes.RedirectNewPaymentMethod]:
    RedirectPaymentMethodClickEventSchema,
  [CheckoutInteractionEventTypes.SelectInstallments]:
    SelectInstallmentsEventSchema,
  [CheckoutInteractionEventTypes.PaymentAttempt]: PaymentAttemptEventSchema,
  [CheckoutInteractionEventTypes.PaymentCancel]: PaymentAttemptEventSchema,
  [CheckoutInteractionEventTypes.InsuranceToggle]: InsuranceToggleEventSchema,
  [CheckoutInteractionEventTypes.GoToInsurance]: BaseEventSchema,
  [CheckoutInteractionEventTypes.ClickPrescriptionsNext]:
    ClickPrescriptionsNextEventSchema,
  [CheckoutInteractionEventTypes.LastWhimCheckProduct]: LastWhimCheckProduct,
  [CheckoutInteractionEventTypes.SelectMekiCredit]: BaseEventSchema,
  [CheckoutInteractionEventTypes.UnselectMekiCredit]: BaseEventSchema,
  [CheckoutInteractionEventTypes.SelectInsurance]: SelectInsuranceEventSchema,
  [CheckoutInteractionEventTypes.UnselectInsurance]: BaseEventSchema,
};
